import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogGeneral } from 'app/dialogs/DialogGeneral';
import { formatKennitala } from 'app/helpers/formatKennitala';
import { formatPersonDetails } from 'app/helpers/formatPersonDetails';
import { ExposedReadUserDetailsRes } from 'app/interfaces/responses/Exposed/exposedReadUserDetailsRes';

export interface DialogDocumentsAddSingleConfirmData {
    ssn: string;
    name: string;
    fileName: string;
    templateName: string;
    documentType: 'file' | 'template';
}

@Component({
    selector: 'dialog-documents-add-single-confirm',
    templateUrl: 'dialog-documents-add-single-confirm.html',
    styleUrls: ['dialog-documents-add-single-confirm.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class DialogDocumentsAddSingleConfirm extends DialogGeneral {
    userDetails: ExposedReadUserDetailsRes = null;
    filenameIncludesSSN: boolean = false;
    additionalFilenameConfirmCheck: boolean = false;

    constructor(
        public matDialogRef: MatDialogRef<DialogDocumentsAddSingleConfirm>,
        public dialogRef: MatDialogRef<DialogDocumentsAddSingleConfirm>,
        public dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA)
        public data: DialogDocumentsAddSingleConfirmData
    ) {
        super(matDialogRef);
    }

    formatPersonDetails = formatPersonDetails;

    ngOnInit(): void {
        this.filenameIncludesSSN =
            this.data.fileName.includes(this.data.ssn) || this.data.fileName.includes(formatKennitala(this.data.ssn));
    }
}
